export const SubSegment = {
  Accountancy: "Accountancy",
  AnimalServices: "Animal Services",
  CharityAndDonation: "Charity & Donation",
  CleaningServices: "Cleaning Services",
  ConsultingServices: "Consulting Services",
  Education: "Education",
  FoodAndDrink: "Food & Drink",
  Gym: "Gym",
  HairAndBeauty: "Hair & Beauty",
  Healthcare: "Healthcare",
  HomeServices: "Home Services",
  Law: "Law",
  MembershipClubsNonSports: "Membership Clubs (Non sports)",
  OtherFinancialServices: "Other Financial Services",
  OtherFitnessAndWellness: "Other Fitness & Wellness",
  OtherPersonalServices: "Other Personal Services",
  OtherProfessionalServices: "Other Professional Services",
  PT: "PT",
  RetailAndWholesale: "Retail & Wholesale",
  RoadAndRail: "Road & Rail",
  SportsClubs: "Sports Clubs",
  Travel: "Travel",
  Utilities: "Utilities",
} as const;

export type SubSegment = (typeof SubSegment)[keyof typeof SubSegment];
